import React from 'react';

export const ArrowExpand: React.FC = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.10035 8.90011C4.9295 8.72926 4.65249 8.72926 4.48163 8.90011L0.897462 12.4843L0.897462 10.0625C0.897462 9.82086 0.701586 9.62498 0.459962 9.62498C0.218337 9.62498 0.0224609 9.82086 0.0224612 10.0625L0.0224609 13.5405C0.0224609 13.7821 0.218337 13.978 0.459961 13.978L3.93794 13.978C4.17957 13.978 4.37544 13.7821 4.37544 13.5405C4.37544 13.2989 4.17957 13.103 3.93794 13.103L1.51618 13.103L5.10035 9.51883C5.2712 9.34798 5.2712 9.07097 5.10035 8.90011Z"
      fill="#325A6D"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.89965 5.09989C9.0705 5.27074 9.34751 5.27074 9.51837 5.09989L13.1025 1.51572L13.1025 3.93752C13.1025 4.17914 13.2984 4.37502 13.54 4.37502C13.7817 4.37502 13.9775 4.17914 13.9775 3.93752L13.9775 0.459498C13.9775 0.217874 13.7817 0.0219979 13.54 0.0219979L10.0621 0.0220003C9.82043 0.0220003 9.62456 0.217876 9.62456 0.459501C9.62456 0.701126 9.82043 0.897001 10.0621 0.897001L12.4838 0.896999L8.89965 4.48117C8.7288 4.65202 8.7288 4.92903 8.89965 5.09989Z"
      fill="#325A6D"
    />
  </svg>
);
